(function () {
  "use strict";

  const DEV_HOSTNAMES = ["127.0.0.1", "localhost"];
  const isDev = DEV_HOSTNAMES.indexOf(window.location.hostname) !== -1;

  if (!isDev) return;

  const BLOCKED_APPS = ["swishlist"];

  function removeAppElements() {
    const scripts = document.querySelectorAll("script[src]");
    scripts.forEach((script) => {
      const src = script.getAttribute("src") || "";
      BLOCKED_APPS.forEach((app) => {
        if (src.toLowerCase().indexOf(app) !== -1) {
          script.remove();
        }
      });
    });

    const links = document.querySelectorAll("link[href]");
    links.forEach((link) => {
      const href = link.getAttribute("href") || "";
      BLOCKED_APPS.forEach((app) => {
        if (href.toLowerCase().indexOf(app) !== -1) {
          link.remove();
        }
      });
    });
  }

  // Run immediately for elements already in DOM
  removeAppElements();

  // Observe for dynamically injected elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const src =
          node.getAttribute &&
          (node.getAttribute("src") || node.getAttribute("href") || "");
        BLOCKED_APPS.forEach((app) => {
          if (src && src.toLowerCase().indexOf(app) !== -1) {
            node.remove();
          }
        });
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Stop observing after page load to avoid performance impact
  window.addEventListener("load", () => {
    setTimeout(() => {
      observer.disconnect();
    }, 3000);
  });

  console.log("[dev] Blocked apps:", BLOCKED_APPS.join(", "));
})();
